package er.prateek.crossly.data.model

enum class ClueDirection {
    ACROSS,
    DOWN,
}
